<template>
  <div v-if="filterListBulk" class="mobile-filter-wrapper w-100">
    <!-- Erste 12 Facetten -->
    <item-filter
        v-for="facet in facets.slice(0, initialVisibleCount)"
        :facet="facet"
        :key="'mobile_always_' + facet.id"
        :padding-classes="paddingClasses"
        :padding-inline-styles="paddingInlineStyles"
        :filter-list-bulk="filterListBulk"
        :active-facet-id="activeFacetId"
        :show-badges="showBadges"
        @toggle-accordion="activeFacetId = $event"
    />
    <transition name="fade">
      <div v-show="showMobileMore" class="mobile-filter-wrapper mt-0">
        <item-filter
            v-for="facet in facets.slice(initialVisibleCount)"
            :facet="facet"
            :key="'mobile_collapsed_' + facet.id"
            :padding-classes="paddingClasses"
            :padding-inline-styles="paddingInlineStyles"
            :filter-list-bulk="filterListBulk"
            :active-facet-id="activeFacetId"
            @toggle-accordion="activeFacetId = $event"
        />
      </div>
    </transition>
    <!-- Button + Restliche Facetten -->
    <button
        v-if="facets.length > initialVisibleCount"
        type="button"
        class="btn more-filter btn-medium-large position-relative d-flex align-items-center justify-content-center"
        @click="showMobileMore = !showMobileMore"
    >
      <span style="padding-top: 2px">{{ toggleButtonTextMobile }}</span>
      <svg xmlns="http://www.w3.org/2000/svg"
           width="13.182" height="8"
           viewBox="0 0 13.182 8"
           :class="['position-absolute arrDown', { rotate180: showMobileMore }]"
           style="right: .5rem"
      >
        <path id="chevron-down-solid"
              d="M11.735,131.282l-5.867-5.867a.724.724,0,0,1,0-1.025l.684-.684a.724.724,0,0,1,1.023,0l4.671,4.649,4.671-4.649a.724.724,0,0,1,1.023,0l.684.684a.724.724,0,0,1,0,1.025l-5.867,5.867A.725.725,0,0,1,11.735,131.282Z" transform="translate(-5.656 -123.494)" fill="#464646"/>
      </svg>
    </button>
  </div>

  <div v-else class="filter-wrapper" v-show="facets && facets.length > 0">
    <div class="filter-list d-grid" style="margin-bottom: 10px">
      <!-- Erste 12 Filter dauerhaft sichtbar -->
      <item-filter
          v-for="facet in facets.slice(0,initialVisibleCount)"
          :facet="facet"
          :key="'always_' + facet.id"
          :show-badges="showBadges"
      >
      </item-filter>
    </div>
    <button
        v-if="facets.length > initialVisibleCount"
        type="button"
        class="btn more-filter btn-medium-large position-relative d-flex align-items-center justify-content-center"
        @click="showMore = !showMore"
        style="margin-bottom: 10px"
    >
      <span style="padding-top: 2px">{{ toggleButtonText }}</span>
      <svg xmlns="http://www.w3.org/2000/svg"
           width="13.182" height="8"
           viewBox="0 0 13.182 8"
           :class="['position-absolute arrDown', { rotate180: showMore }]"
           style="right: .5rem"
      >
        <path id="chevron-down-solid"
              d="M11.735,131.282l-5.867-5.867a.724.724,0,0,1,0-1.025l.684-.684a.724.724,0,0,1,1.023,0l4.671,4.649,4.671-4.649a.724.724,0,0,1,1.023,0l.684.684a.724.724,0,0,1,0,1.025l-5.867,5.867A.725.725,0,0,1,11.735,131.282Z" transform="translate(-5.656 -123.494)" fill="#464646"/>
      </svg>
    </button>
    <!-- Collapsible für restliche Filter -->

    <transition name="fade">
      <div v-show="showMore" class="filter-collapse" :id="'filter-collapse_' + _cid">
        <div class="component-loading" :class="{ 'is-loading': isLoading }">
          <div class="filter-list d-grid">
            <!-- Restliche Filter ab Index 12 -->
            <item-filter
                v-for="facet in facets.slice(initialVisibleCount)"
                :facet="facet"
                :key="'collapsed_' + facet.id"
                :show-badges="showBadges"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ItemFilter from "./ItemFilter.vue";
import { ComponentIdMixin } from "../../../mixins/componentId.mixin";

export default {

    name: "item-filter-list",

    components:
    {
        ItemFilter
    },

    mixins: [ComponentIdMixin], // Experimental mixin, may be removed in the future.

    props: {
        showBadges: Boolean,
        filterListBulk: Boolean,
        facetData:
        {
            type: Array,
            default()
            {
                return [];
            }
        },
        allowedFacetsTypes:
        {
            type: Array,
            default: () => []
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
      initialVisibleCount: {
        type: Number,
        default: 12
      }
    },

    computed:
    {
        ...mapState({
            facets(state)
            {
                if (!this.allowedFacetsTypes.length)
                {
                    return state.itemList.facets;
                }

                return state.itemList.facets
                    .filter(facet => this.allowedFacetsTypes.includes(facet.id) || this.allowedFacetsTypes.includes(facet.type));
            },
            isLoading: state => state.itemList.isLoading,
            selectedFacets: state => state.itemList.selectedFacets
        }),
      toggleButtonText() {
        return this.$translate(
            this.showMore
                ? "ETCeresCoconut::Template.categoryLessFilters"
                : "ETCeresCoconut::Template.categoryMoreFilters"
        );
      },
      toggleButtonTextMobile() {
        return this.$translate(
            this.showMobileMore
                ? "ETCeresCoconut::Template.categoryLessFilters"
                : "ETCeresCoconut::Template.categoryMoreFilters"
        );
      }
    },

  data() {
    return {
      activeFacetId: null,
      showMobileMore: false,
      showMore: false
    };
  },
    created()
    {
        if (!this.$store.state.itemList.facets?.length)
        {
            this.$store.commit("addFacets", this.facetData);
        }
    }
}
</script>
